export const getScaleDataByIndustryTotal = data => {
  const total = data.reduce((acc, { O }) => acc + O, 0);
  const industryTotal = data.reduce((acc, { I }) => acc + I, 0);
  const scaledData = data.map(element => ({
    ...element,
    O: (element.O * industryTotal) / total
  }));
  return [total, industryTotal, scaledData];
};
